var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseApiClient } from "./BaseApiClient";
export var SPORT_ENDPOINTS = {
    ALL: "/Sports",
    GROUPED_BY_DATE: "/Sports/GetGroupedByDate"
};
/**
 * SportsApiClient - client for fetching Sports BFF endpoints
 * @export
 * @class SportsApiClient
 * @extends {BaseApiClient}
 */
var SportsApiClient = /** @class */ (function (_super) {
    __extends(SportsApiClient, _super);
    function SportsApiClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Fetch all sports from BFF
     * @param {request} SportsRequest
     * @throws {RequiredError}
     * @memberof SportsApiClient
     */
    SportsApiClient.prototype.getAllSports = function (request) {
        var fetchOptions = {
            request: request,
            fetchOptOverride: {}
        };
        return this.executeRequest(SPORT_ENDPOINTS.ALL, fetchOptions);
    };
    /**
     * Get sports grouped by Date from BFF
     * @param {request} SportsGroupedByDateRequest
     * @throws {RequiredError}
     * @memberof SportsApiClient
     */
    SportsApiClient.prototype.getSportsGroupedByDate = function (request) {
        var fetchOptions = {
            request: request,
            fetchOptOverride: {}
        };
        return this.executeRequest(SPORT_ENDPOINTS.GROUPED_BY_DATE, fetchOptions);
    };
    return SportsApiClient;
}(BaseApiClient));
export { SportsApiClient };
//# sourceMappingURL=SportsApiClient.js.map